var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreditCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "catd-46",
    transform: "translate(-1367 -4047)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83179",
    "data-name": "Path 83179",
    d: "M23,0C40.851,0,46,5.149,46,23S40.851,46,23,46,0,40.851,0,23,5.149,0,23,0Z",
    transform: "translate(1367 4047)",
    fill: "#f2f3f7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_167294",
    "data-name": "Group 167294",
    transform: "translate(796 3351)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "credit-card_1_",
    "data-name": "credit-card (1)",
    transform: "translate(583 711)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_149761",
    "data-name": "Rectangle 149761",
    d: "M2-.75H20A2.753,2.753,0,0,1,22.75,2V14A2.753,2.753,0,0,1,20,16.75H2A2.753,2.753,0,0,1-.75,14V2A2.753,2.753,0,0,1,2-.75Zm18,16A1.251,1.251,0,0,0,21.25,14V2A1.251,1.251,0,0,0,20,.75H2A1.251,1.251,0,0,0,.75,2V14A1.251,1.251,0,0,0,2,15.25Z",
    transform: "translate(0 0)",
    fill: "#636974"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_303",
    "data-name": "Line 303",
    d: "M22,.75H0A.75.75,0,0,1-.75,0,.75.75,0,0,1,0-.75H22a.75.75,0,0,1,.75.75A.75.75,0,0,1,22,.75Z",
    transform: "translate(0 6)",
    fill: "#636974"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_7294",
    "data-name": "Path 7294",
    d: "M3.3.75H0A.75.75,0,0,1-.75,0,.75.75,0,0,1,0-.75H3.3A.75.75,0,0,1,4.05,0,.75.75,0,0,1,3.3.75Z",
    transform: "translate(597.85 723.1)",
    fill: "#636974"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardIcon);
export default __webpack_public_path__ + "static/media/creditCard_icon.4f8b61a7472c20383a01a02ffbb00f19.svg";
export { ForwardRef as ReactComponent };